<template>
  <div class="entity team">
    <sui-form-fields>
      <EntityInput v-model="entity.name" fieldName="name" ref="name" v-if="visibleFields.name" />
      <EntityInput v-model="entity.email" fieldName="email" ref="email" v-if="visibleFields.email" />
    </sui-form-fields>
    <EntityInput v-model="entity.avatar" fieldName="avatar" ref="avatar" v-if="visibleFields.avatar" />
  </div>
</template>

<script>
  import EntityInput from '@/components/forms/EntityInput'
  import FormEntity from '@/mixins/FormEntity'

  export default {
    name: 'FormAccount',
    mixins: [
      FormEntity,
    ],
    components: {
      EntityInput,
    },
    data() {
      return {
        object: 'Account',
        commonFields: ['name'],
      }
    },
  }
</script>
